import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useLazyForgotPasswordEmailQuery } from "../../../../../redux/api/user/userAPI";
import { OvstErrorCode } from "../../../enums/ovst-error-codes";
import { AppRoute } from "../../../interfaces/app-routes";
import { IHttpError } from "../../../interfaces/http-errror";
import AppButton from "../../../ui-elements/buttons/app-button/app-button";
import AppInput from "../../../ui-elements/input/app-input";
import { emailRegex } from "../../../utils/regex";
import { showErrorMessage, showSuccessMessage } from "../../../utils/toast";
interface IForgotPassword {
  email: string;
}

const defaultFormValues: IForgotPassword = {
  email: "",
};

const ForgotPasswordForm = () => {
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");

  const [triggerForgotPassword, { isLoading }] =
    useLazyForgotPasswordEmailQuery();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IForgotPassword>({
    defaultValues: { ...defaultFormValues },
  });

  const onSubmit = (data: IForgotPassword) => {
    triggerForgotPassword({ email: data.email })
      .unwrap()
      .then(() => {
        setErrorMessage("");
        showSuccessMessage("Reset link sent successful");
        navigate(AppRoute.VERIFY_EMAIL, {
          state: {
            value: data.email,
            whereTo: "reset",
          },
        });
      })
      .catch((error: IHttpError) => {
        if (
          error.status === 412 &&
          error.ovstErrorCode === OvstErrorCode.OVST_0001
        ) {
          setErrorMessage(
            "We couldn't find an account associated with the email you entered.",
          );
          return;
        }

        showErrorMessage("Failed to send reset link");
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col>
          <AppInput
            name="email"
            leftIcon="mail"
            placeholder="Email"
            type="email"
            register={register("email", {
              required: "Email is required",
              pattern: {
                value: emailRegex,
                message: "Please enter a valid email address",
              },
            })}
            errors={errors}
          />
        </Col>
      </Row>
      {errorMessage && !errors.email && (
        <Row className="mt-1">
          <Col className="text-center error">{errorMessage}</Col>
        </Row>
      )}
      <Row className="mt-5">
        <Col>
          <AppButton
            text="Send Reset Link"
            size="medium"
            type="submit"
            isLoading={isLoading}
            disabled={isLoading}
          />
        </Col>
      </Row>
    </form>
  );
};

export default ForgotPasswordForm;
